import { useContext, useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import TabComponent from "./components/TabComponent";
import { Col, Row } from "react-bootstrap";
import Sidebar from "./components/sidebar/Sidebar";
import { DataContext } from "./context/DataProvider";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { IconButton } from "@mui/material";
import axiosMain from "./axiosMain";
import Cookies from "js-cookie";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import PrivateRouter from "./PrivateRouter";
import SignUp from "./pages/SignUp";
import { ToastContainer } from "react-toastify";
import VerifyPage from "./pages/VerifyPage";
import { registerLoader } from "./utils/loaderController";
import loadingImg from "../src/assets/logo/tender-gpt-loader.gif";
import SuccessPayment from "./pages/Payment/SuccessPayment";
import ReferAndEarn from "./pages/ReferEarn/ReferAndEarn";
import Referral from "./pages/ReferEarn/Referral";


function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // Register global loader callbacks
    registerLoader(() => setLoading(true), () => setLoading(false));
  }, []);

  // const { showSideBar, setShowShowSideBar } = useContext(DataContext);
  // const [sidebarClass, setSidebarClass] = useState("sidebar-hidden");
  const { tenderGPTData, resultGPTData, history, setHistory, searchType } =
    useContext(DataContext);

  // useEffect(() => {
  //   if (history?.length === 0) {
  //     axiosMain
  //       .get(
  //         `http://common.tendertiger.co.in/api/Common/searchHistory?userDetailId=984028&searchFrom=${
  //           searchType === "Tender" ? "tenderai" : "resultai"
  //         }`
  //       )
  //       ?.then((res) => {
  //         console.log(res.data);
  //         // searchType === "Tender"
  //         //   ? Cookies.set("tenderGPTDataHistory", JSON.stringify(res.data))
  //         //   : Cookies.set("resultGPTDataHistory", JSON.stringify(res.data));
  //         // setHistory(res.data);
  //         if (
  //           res.data.length >
  //           [
  //             ...JSON.parse(
  //               Cookies.get(
  //                 searchType === "Tender"
  //                   ? "tenderGPTDataHistory"
  //                   : "resultGPTDataHistory"
  //               )
  //             ),
  //           ].length
  //         ) {
  //           setHistory(
  //             searchType === "Tender"
  //               ? [
  //                   ...new Set([
  //                     ...(JSON.parse(Cookies.get("tenderGPTDataHistory")) ||
  //                       "[]"),
  //                     ...res.data,
  //                   ]),
  //                 ]
  //               : [
  //                   ...new Set([
  //                     ...(JSON.parse(Cookies.get("resultGPTDataHistory")) ||
  //                       "[]"),
  //                     ...res.data,
  //                   ]),
  //                 ]
  //           );
  //           searchType === "Tender"
  //             ? Cookies.set(
  //                 "tenderGPTDataHistory",
  //                 JSON.stringify([
  //                   ...new Set([
  //                     ...(JSON.parse(Cookies.get("tenderGPTDataHistory")) ||
  //                       "[]"),
  //                     ...res.data,
  //                   ]),
  //                 ])
  //               )
  //             : Cookies.set(
  //                 "resultGPTDataHistory",
  //                 JSON.stringify([
  //                   ...new Set([
  //                     ...(JSON.parse(Cookies.get("resultGPTDataHistory")) ||
  //                       "[]"),
  //                     ...res.data,
  //                   ]),
  //                 ])
  //               );
  //         }
  //       })
  //       ?.catch((err) => console.log(err));
  //   }
  // }, []);
  return (
    <>
   
      {loading && (
        <div className="global-loader">
          <img src={loadingImg} alt="Loading..." className="loader-image" />
        </div>
      )}

      <Router>
        <Routes>
          <Route element={<PrivateRouter />}>
            {/* <Route path="/chat/:id" element={<TabComponent />} /> */}
            <Route path="/" element={<TabComponent />} />
            <Route path="/chat" element={<TabComponent />} />
            <Route path="/Payment-Success" element={<SuccessPayment />} />
            {/* <Route path="/Refer" element={<ReferAndEarn />} /> */}
            <Route path="/User/Account" element={<Referral />} />
          </Route>
          <Route path="/Verify" element={<VerifyPage />} />

          {/* <Route path="/sign-up" element={<OTPVerificationForm />} /> */}
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
